<template>
  <Page>
    <div class="container container--no-padding ">
      <HomeSubscribeForm class="h-margin-bottom-xl" />
      <div class="container container--small container--inline">
        <ServiceBanner class="h-margin-top-xl" />
      </div>
    </div>
  </Page>
</template>
<script setup>
import {
  formatCanonical,
  formatOpenGraph,
  formatMetaDescription
} from '~/helpers/metadata'
const { $api } = useNuxtApp()
const { data } = await useAsyncData('newsletter', () => $api('navigation/newsletter'))

if (data.value) {
  const metaData = data.value.metaData
  useHead({
    title: metaData.pageTitle,
    titleTemplate: '%s',
    link: [...formatCanonical(metaData)],
    meta: [
      ...formatOpenGraph(metaData.openGraph),
      formatMetaDescription(metaData)
    ],
    script: [{ type: 'application/ld+json', innerHTML: metaData.schemaOrg }] // Structured data

  })
}
</script>
